import axios from "axios";
import { URL } from "../config/config";

const apiClient = axios.create({
  baseURL: URL,
});

export default apiClient;
